import { type ReactNode } from 'react'
import { Head } from '@inertiajs/react'
import AdminLayout from '@/components/AdminLayout'
import ResearchNav from '@/components/admin/research/ResearchNav'
import ResearchOrganizationForm from '@/components/admin/research/ResearchOrganizationForm'
import type { ResearchOrganizationDetail } from '@/types/research'

type Props = {
  organization: ResearchOrganizationDetail
  causes: string[]
}

export default function ResearchOrganizationEdit({ organization, causes }: Props) {
  return (
    <>
      <Head title={`Research - Edit ${organization.name}`} />
      <div>
        <h1 className="text-3xl font-semibold tracking-tight font-serif">Research Database</h1>
        <div className="mt-4">
          <ResearchNav />
        </div>
        <h2 className="mb-6 text-2xl font-semibold tracking-tight">Edit {organization.name}</h2>
        <div className="max-w-3xl">
          <ResearchOrganizationForm organization={organization} causes={causes} />
        </div>
      </div>
    </>
  )
}

ResearchOrganizationEdit.layout = (page: ReactNode) => <AdminLayout>{page}</AdminLayout>
